export function getFileExtensionFromContent(content) {
  let data = content || {};
  if (typeof content === 'string') {
    try {
      data = JSON.parse(content);
    } catch (e) {
      data = { name: content };
    }
  }
  const source = String(data.name || data.fileName || data.url || '');
  const cleanSource = source.split('?')[0].split('#')[0];
  const match = cleanSource.match(/\.([a-z0-9]+)$/i);
  return match ? match[1].toLowerCase() : '';
}

export function getFileIconMetaByExtension(ext) {
  const audioTypes = ['mp3', 'wav', 'flac', 'm4a', 'aac', 'ogg', 'wma', 'amr'];
  const videoTypes = ['mp4', 'avi', 'mov', 'mkv', 'wmv', 'flv', 'webm', '3gp', 'm4v'];
  const wordTypes = ['doc', 'docx', 'wps'];
  const excelTypes = ['xls', 'xlsx', 'csv', 'et'];
  const pptTypes = ['ppt', 'pptx', 'dps'];
  const imageTypes = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg'];
  const archiveTypes = ['zip', 'rar', '7z', 'tar', 'gz'];
  const codeTypes = ['txt', 'md', 'json', 'xml', 'html', 'css', 'js', 'java', 'kt', 'py'];
  if (audioTypes.includes(ext)) {
    return { className: 'file-icon-audio', mark: '♪' };
  }
  if (videoTypes.includes(ext)) {
    return { className: 'file-icon-video', mark: '▶' };
  }
  if (wordTypes.includes(ext)) {
    return { className: 'file-icon-word', mark: 'W' };
  }
  if (excelTypes.includes(ext)) {
    return { className: 'file-icon-excel', mark: 'X' };
  }
  if (pptTypes.includes(ext)) {
    return { className: 'file-icon-ppt', mark: 'P' };
  }
  if (ext === 'pdf') {
    return { className: 'file-icon-pdf', mark: 'PDF' };
  }
  if (imageTypes.includes(ext)) {
    return { className: 'file-icon-image', mark: 'IMG' };
  }
  if (archiveTypes.includes(ext)) {
    return { className: 'file-icon-archive', mark: 'ZIP' };
  }
  if (codeTypes.includes(ext)) {
    return { className: 'file-icon-code', mark: '{ }' };
  }
  return { className: 'file-icon-default', mark: ext ? ext.slice(0, 3).toUpperCase() : '' };
}

export function getFileIconMetaFromContent(content) {
  return getFileIconMetaByExtension(getFileExtensionFromContent(content));
}
